module.exports = __webpack_public_path__ + "img/3RD ROW SEAT.3745b504.svg";